import {
	Icon,
	Pressable,
} from 'native-base';

export default function IconButton(props) {
	const propsIcon = props._icon || {},
		icon = props.icon || <Icon {...propsIcon} />;
	return <Pressable
				borderRadius="sm"
				colorScheme="primary"
				flexDirection="row"
				justifyContent="center"
				alignItems="center"
				p={2}
				{...props}
			>
				{icon}
			</Pressable>;
}
